<script setup lang="ts">
  declare let gtagO: Function;
  declare let frontendConfig: any;

  function goExternal(page: string): void {
    let url: string = '';
    switch (page) {
      case "agente":
        url = frontendConfig.homeLinks.agente;
        break;
      case "shop":
        url = frontendConfig.homeLinks.shop;
        break;
      case "scopri":
        url = frontendConfig.homeLinks.scopri;
        break;
    }

    if (url != "") {
      gtagO({
        event: 'outboundlink', 
        target: url,
        posizione: 'bottom HP'
      })

      window.open(url, "_blank");
    }
  }

  function isRebranding(): boolean {
    return frontendConfig.rebranding;
  }
</script>

<template>
  <div>
    <div class="jumbo404">
      <div class="container page404">
        <div class="row">
          <div class="col-6 jumboWhite p-5">
            <h1 class="display-5 fw-bold">
              <img v-if="!isRebranding()" alt="Strategia" src="../assets/logo.svg"/>
              <img v-if="isRebranding()" alt="Strategia" src="../assets/LOGO_STRATEGIA.png"/>
            </h1>
            <p class="fs-4">
              Analizza il tuo caso giuridico e trova<br>la <b>sentenza perfetta</b> per la tua strategia.
            </p>
          </div>
          <div class="col-6 p-5">
          </div>
        </div>
      </div>
    </div>

    <div class="p-3 mb-2 bg-body-tertiary text-center">
      <h3>
        <b>Uno strumento indispensabile per una ricerca veloce, affidabile e precisa sulla giurisprudenza di merito.</b>
      </h3>
    </div>

    <div class="container mt-4 page404">
      <div class="p-3 mb-2 text-center text-color-gfl">
        <h5>Scopri tutte le funzionalità di Strategia da solo o integrato con la banca dati Dejure.</h5>
      </div>

      <div class="row align-items-md-stretch secondrow">
        <div class="col-md-2 p-3">
          <div class="h-100 p-2 border rounded-1 bordoblu text-center">
            <div>
              <i class="bi bi-magic icon404"></i>
            </div>
            <p>Costruisci rapidamente una <b>panoramica</b> sul tuo <b>caso giuridico</b>, attraverso un <b>percorso
              guidato</b> passo dopo passo.
            </p>
          </div>
        </div>
        <div class="col-md-2 p-3">
          <div class="h-100 p-2 border rounded-1 bordoblu text-center">
            <div>
              <i class="bi bi-graph-up icon404"></i>
            </div>
            <p>Le <b>infografiche</b> ti permetteranno di <b>comprendere</b> al meglio il <b>contesto</b> e definire i
              contorni della tua <b>ricerca</b>.
            </p>
          </div>
        </div>
        <div class="col-md-2 p-3">
          <div class="h-100 p-2 border rounded-1 bordoblu text-center">
            <div>
              <i class="bi bi-funnel icon404"></i>
            </div>
            <p><b>Migliora la tua ricerca</b> filtrando per foro di competenza, esito del giudizio, durata del
              procedimento e molto altro.
            </p>
          </div>
        </div>
        <div class="col-md-2 p-3">
          <div class="h-100 p-2 border rounded-1 bordoblu text-center">
            <div>
              <i class="bi bi-file-earmark-text icon404"></i>
            </div>
            <p>Trova le <b>sentenze</b> più <b>adatte</b> alla tua strategia, consultale nel <b>dettaglio</b> o in <b>sintesi</b>
              con l'<b>AI</b>.
            </p>
          </div>
        </div>
        <div class="col-md-4 p-3">
          <div class="h-100 p-2 border rounded-1 bordoblu text-center">
            <div>
              <img src="https://dejure.it/Content/images/LogoDejureSVG2.svg" alt="DeJure" class="img404">
            </div>
            <p>Con un <b>abbonamento al DeJure</b> potrai ampliare la tua ricerca sfruttando tutte le funzionalità della
              banca dati.
            </p>
          </div>
        </div>
      </div>

      <div class="row align-items-md-stretch secondrow">
        <div class="col-md-4 p-3">
          <div class="h-100">
            <button class="btn btn-primary btn-lg w-100" @click="goExternal('agente')">Contatta l’agente</button>
          </div>
        </div>
        <div class="col-md-4 p-3">
          <div class="h-100">
            <button class="btn btn-primary btn-lg w-100" @click="goExternal('shop')">Vai allo shop</button>
          </div>
        </div>
        <div class="col-md-4 p-3">
          <div class="h-100">
            <button class="btn btn-outline-primary btn-lg w-100" @click="goExternal('scopri')">Scopri di più</button>
          </div>
        </div>
      </div>

      <div class="row p-3"></div>
    </div>
  </div>
</template>